'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React 15.5 parse value as number
// to decide whether update node.value when <input type="number">
// That is to say pass '12.00' to a number input
// that has value '12' will not trigger update
// so we can't use `type: number`

// always use typing to input number, date, string value
// for date value, Avoid browser to use date widget

function Input(props) {
  var isInvalid = props.isInvalid,
      inputRef = props.inputRef,
      passing = _objectWithoutProperties(props, ['isInvalid', 'inputRef']);

  return _react2.default.createElement('input', _extends({
    ref: inputRef,
    type: 'text',
    style: isInvalid ? { borderColor: 'red' } : null,
    className: isInvalid ? 'form-control is-invalid' : 'form-control'
  }, passing));
}

Input.propTypes = {
  isInvalid: _propTypes.bool,
  inputRef: _propTypes.func
};

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/Input.js
// module id = 1689
// module chunks = 0